<template>
  <svg width="37" height="18"
       viewBox="0 0 37 18"
       fill="none"
       :stroke="fill"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M35 9L0.999999 9" stroke-width="2" stroke-linecap="round"/>
    <path class="arr_right" d="M35.0527 9L22.0624 16.5" stroke-width="2" stroke-linecap="round"/>
    <path class="arr_left" d="M35.0527 9L22.0624 1.5" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: "ArrowRightIcon",
  props: {
    fill: {
      type: String,
      default: '#3A913F'
    },
    rotate: {
      type: Boolean,
      default: false
    }
  }
}
</script>
